'use client';

import { cn } from '@/lib/cn';
import { useAnalytics } from '@/hooks/useAnalytics';

interface RetryMessageProps {
  errorMessage: string;
  onRetry: () => void;
}

export function RetryMessage({ errorMessage, onRetry }: RetryMessageProps) {
  const analytics = useAnalytics();
  return (
    <div className="mt-2 flex items-center justify-end gap-2 text-body-2 text-secondary">
      <span>{errorMessage}</span>
      <button
        onClick={() => {
          analytics.track('user_try_again');
          onRetry();
        }}
        className={cn('text-accent hover:text-accent-hover underline', 'text-body-2 font-semibold')}
      >
        Try again
      </button>
    </div>
  );
}
